import { getRequest } from '../../services/api';
import type { ApiResponse } from '../../services/types';

import type { CategoryBanner } from './types';

export async function fetchCategoryBanners(lang: string): Promise<CategoryBanner[]> {
  const response = await getRequest<ApiResponse<CategoryBanner[], 'banners'>>('category-banners', { lang });
  return response.data.banners;
}
